import FederalSealIcon from './FederalSealIcon'

export default FederalSealIcon
